import {useSessionStore} from "@/src/modules/auth/store/session";
import type {Session} from "@/src/modules/auth/types";

const ADMIN_SESSION_BACKUP_KEY = "admin_session_backup";
const ADMIN_TOKEN_BACKUP_KEY = "admin_token_backup";

const IMPERSONATION_TOKEN_BACKUP_KEY = "impersonation_token_backup";

const IMPERSONATION_ACTIVE_KEY = "impersonation_active";



export function getAdminSessionBackup(): Session | null {
  if (typeof sessionStorage === "undefined") return null;

  const raw = sessionStorage.getItem(ADMIN_SESSION_BACKUP_KEY);
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as Session;
      if (parsed?.access_token) return parsed;
    } catch {
      // fall through to legacy token-only backup
    }
  }

  const token = sessionStorage.getItem(ADMIN_TOKEN_BACKUP_KEY);
  if (!token) return null;

  return {
    access_token: token,
    token_type: "Bearer",
    expires_at: "",
  };
}

export function getAdminTokenBackup(): string | null {
  return getAdminSessionBackup()?.access_token ?? null;
}

export function setAdminSessionBackup(session: Session): void {
  sessionStorage.setItem(ADMIN_SESSION_BACKUP_KEY, JSON.stringify(session));
  sessionStorage.setItem(ADMIN_TOKEN_BACKUP_KEY, session.access_token);
}

export function setAdminTokenBackup(token: string): void {
  sessionStorage.setItem(ADMIN_TOKEN_BACKUP_KEY, token);
}

export function clearAdminTokenBackup(): void {
  sessionStorage.removeItem(ADMIN_SESSION_BACKUP_KEY);
  sessionStorage.removeItem(ADMIN_TOKEN_BACKUP_KEY);
}



export function getImpersonationTokenBackup(): string | null {

  if (typeof sessionStorage === "undefined") return null;

  return sessionStorage.getItem(IMPERSONATION_TOKEN_BACKUP_KEY);

}



export function setImpersonationTokenBackup(token: string): void {

  sessionStorage.setItem(IMPERSONATION_TOKEN_BACKUP_KEY, token);

}



export function clearImpersonationTokenBackup(): void {

  sessionStorage.removeItem(IMPERSONATION_TOKEN_BACKUP_KEY);

}



export function isImpersonationActiveFlag(): boolean {

  if (typeof sessionStorage === "undefined") return false;

  return sessionStorage.getItem(IMPERSONATION_ACTIVE_KEY) === "1";

}



export function setImpersonationActiveFlag(active: boolean): void {

  if (active) {

    sessionStorage.setItem(IMPERSONATION_ACTIVE_KEY, "1");

  } else {

    sessionStorage.removeItem(IMPERSONATION_ACTIVE_KEY);

  }

}



export function clearImpersonationSessionFlags(): void {

  clearAdminTokenBackup();

  clearImpersonationTokenBackup();

  setImpersonationActiveFlag(false);

}



/** True when the session bearer is the impersonation token (not the stored admin backup). */

export function isClientUsingImpersonationBearer(): boolean {

  const adminBackup = getAdminTokenBackup();

  const sessionToken = useSessionStore.getState().session?.access_token;

  if (!sessionToken) return false;

  if (!adminBackup) {
    const impersonationBackup = getImpersonationTokenBackup();
    return Boolean(impersonationBackup && sessionToken === impersonationBackup);
  }

  return sessionToken !== adminBackup;

}


